import UIApplication from 'UIComponents/app/UIApplication';
import { jsx as _jsx } from "react/jsx-runtime";
const Application = props => /*#__PURE__*/_jsx(UIApplication, Object.assign({}, props, {
  name: "ecosystem-marketplace-solutions-app-ui"
}));
export default Application;